module.exports = __webpack_public_path__ + "img/cong-nghe.8e578321.png";